"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentLandingZone = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var react_sortablejs_1 = require("react-sortablejs");
// NOTE: Swiper 6 required until ESM is supported in Jest / CRA
var react_2 = require("swiper/react");
require("swiper/swiper.min.css");
require("swiper/components/navigation/navigation.min.css");
var core_2 = __importStar(require("swiper/core"));
var UploadAttachmentsTile_1 = require("../../molecules/UploadAttachmentsTile");
var VideoTile_1 = require("../../molecules/VideoTile");
var ThumbnailTile_1 = require("../../molecules/ThumbnailTile");
var IconChip_1 = require("../../atoms/IconChip");
var useDownload_1 = require("../../hooks/useDownload");
var Lightbox_1 = require("../../molecules/Lightbox");
var styles_1 = __importDefault(require("./styles"));
var Attachments_1 = require("../../utils/Attachments");
// install Swiper modules
core_2.default.use([core_2.Navigation]);
/**
 * "Inner" Component for AttachmentLandingZone
 */
exports.AttachmentLandingZone = react_1.default.memo(function (_a) {
    var idPrefix = _a.idPrefix, _b = _a.existingFiles, existingFiles = _b === void 0 ? [] : _b, _c = _a.existingMedia, existingMedia = _c === void 0 ? [] : _c, acceptedFileTypes = _a.acceptedFileTypes, editable = _a.editable, _d = _a.onChange, onChange = _d === void 0 ? function () { } : _d, _e = _a.onMediaClick, onMediaClick = _e === void 0 ? function () { } : _e, _f = _a.onFileClick, onFileClick = _f === void 0 ? function () { } : _f, selectedFileText = _a.selectedFileText, _g = _a.multipleSelectableFiles, multipleSelectableFiles = _g === void 0 ? false : _g, _h = _a.selectableFiles, selectableFiles = _h === void 0 ? false : _h, _j = _a.draggable, draggable = _j === void 0 ? false : _j, props = __rest(_a, ["idPrefix", "existingFiles", "existingMedia", "acceptedFileTypes", "editable", "onChange", "onMediaClick", "onFileClick", "selectedFileText", "multipleSelectableFiles", "selectableFiles", "draggable"]);
    var classes = (0, styles_1.default)();
    var download = (0, useDownload_1.useDownload)().download;
    var _k = (0, react_1.useState)(existingFiles || []), files = _k[0], setFiles = _k[1];
    var _l = (0, react_1.useState)(existingMedia || []), media = _l[0], setMedia = _l[1];
    var _m = (0, react_1.useState)(), currentSlide = _m[0], setCurrentSlide = _m[1];
    // TODO: should switch to mimetype on platform instead of derived type/ext
    var isVideo = (0, react_1.useCallback)(function (file) {
        return file.type
            ? file.type.toLowerCase().startsWith("video/") ||
                react_common_lib_1.videoExts.includes(file.type)
            : false;
    }, []);
    var isMedia = function (file) {
        return file.type
            ? isVideo(file) || file.type.toLowerCase().startsWith("image/")
            : false;
    };
    // handle click, sending the whole object back
    var handleMediaClick = (0, react_1.useCallback)(function (index) {
        setCurrentSlide(index);
        onMediaClick(media[index]);
    }, [media, onMediaClick]);
    // handle click, sending the whole object back
    var handleFileClick = (0, react_1.useCallback)(function (selectedIndex) {
        var file = files[selectedIndex];
        // download a file, unless we are editing it
        if (!editable && file.original) {
            download({
                href: file.originalSrc,
                filename: file.name,
            });
        }
        // always callback
        onFileClick(file);
    }, [download, editable, files, onFileClick]);
    // add files to state
    var handleAddFiles = function (attachedFiles) {
        var justFiles = attachedFiles.filter(function (file) { return !isMedia(file); });
        var justMedia = attachedFiles.filter(function (file) { return isMedia(file); });
        var fileUpdate = __spreadArray(__spreadArray([], files, true), justFiles, true);
        var mediaUpdate = __spreadArray(__spreadArray([], media, true), justMedia, true);
        var orderedArray = draggable ? (0, Attachments_1.getOrderedFiles)(fileUpdate) : fileUpdate;
        setFiles(orderedArray);
        setMedia(mediaUpdate);
        onChange({ files: fileUpdate, media: mediaUpdate });
    };
    // remove files/media from state by index
    var handleRemove = (0, react_1.useCallback)(function (index, fromMedia) {
        var copy = fromMedia ? __spreadArray([], media, true) : __spreadArray([], files, true);
        var file = copy[index];
        if (file.original) {
            // set as removed so we can track for later
            file.removed = true;
        }
        else {
            // otherwise remove any attachment
            copy.splice(index, 1);
        }
        if (fromMedia) {
            setMedia(copy);
            onChange({ files: files, media: copy });
        }
        else {
            var orderedArray = draggable ? (0, Attachments_1.getOrderedFiles)(copy) : copy;
            setFiles(orderedArray);
            onChange({ media: media, files: orderedArray });
        }
    }, [files, media, onChange, draggable]);
    // handle selection , only accept one element selected at the time
    var handleSelect = (0, react_1.useCallback)(function (index) {
        var copy = __spreadArray([], files, true);
        copy.forEach(function (val, currentIndex) {
            var file = val;
            if (currentIndex === index) {
                file.selectedFile = !file.selectedFile;
            }
            else if (!multipleSelectableFiles)
                file.selectedFile = false;
        });
        setFiles(copy);
    }, [files, multipleSelectableFiles]);
    var handleUpdateFiles = (0, react_1.useCallback)(function (attachedFiles) {
        var orderedArray = draggable
            ? (0, Attachments_1.getOrderedFiles)(attachedFiles)
            : attachedFiles;
        setFiles(attachedFiles);
        onChange({ files: orderedArray, media: media });
    }, [setFiles, onChange, media, draggable]);
    // sugar for different remove actions
    var handleRemoveFile = handleRemove;
    var handleRemoveMedia = (0, react_1.useCallback)(function (index) { return handleRemove(index, true); }, [handleRemove]);
    var handleLightboxClose = function () { return setCurrentSlide(undefined); };
    var getSource = function (file) {
        return file.original
            ? file.thumbnailSrc
            : URL.createObjectURL(file);
    };
    // set size of landing button as it is needed for calcs in swiper wrapper
    var landingButtonSize = "150px";
    var slides = (0, react_1.useMemo)(function () {
        return media.map(function (file, index) {
            var mediaProps = {
                idPrefix: idPrefix,
                name: file.name,
                removable: editable,
                onClick: function () { return !editable && handleMediaClick(index); },
                onRemove: function () { return handleRemoveMedia(index); },
            };
            return (!file.removed &&
                (isVideo(file) ? ((0, jsx_runtime_1.jsx)(react_2.SwiperSlide, __assign({ style: { maxWidth: "250px" } }, { children: (0, jsx_runtime_1.jsx)(VideoTile_1.VideoTile, __assign({ "data-testid": "video-tile" }, mediaProps)) }), "Video".concat(file.name, "__").concat(index))) : (getSource(file) && ((0, jsx_runtime_1.jsx)(react_2.SwiperSlide, __assign({ style: { maxWidth: "250px" } }, { children: (0, jsx_runtime_1.jsx)(ThumbnailTile_1.ThumbnailTile, __assign({ "data-testid": "image-tile", src: getSource(file) }, mediaProps)) }), "Image".concat(file.name, "__").concat(index))))));
        });
    }, [editable, handleMediaClick, handleRemoveMedia, idPrefix, isVideo, media]);
    var fileChips = (0, react_1.useMemo)(function () { return ((0, jsx_runtime_1.jsx)(react_sortablejs_1.ReactSortable, __assign({ disabled: !editable || !draggable, className: classes.chipContainer, direction: "vertical", list: files, setList: handleUpdateFiles, handle: ".drag-handle" }, { children: files.map(function (file, index) { return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ "data-testid": "file-chip", id: "".concat(idPrefix, "FileAttachmentButton"), role: "button", onClick: function () { return !editable && handleFileClick(index); }, className: classes.fileChip, style: { display: "".concat(file.removed ? "none" : "initial") } }, { children: (0, jsx_runtime_1.jsx)(IconChip_1.IconChip, { draggable: draggable, onChange: function () { return editable && handleSelect(index); }, checkable: editable && selectableFiles, checked: file.selectedFile, fileName: file.name, chipText: file.name, fileType: file.type, legendText: selectedFileText, 
                // TODO: where is the onclick!!
                onRemove: function () { return handleRemoveFile(index); }, hideClose: !editable }) }), "File".concat(file.name, "__").concat(index))); }) }))); }, [
        classes.fileChip,
        classes.chipContainer,
        handleUpdateFiles,
        editable,
        draggable,
        files,
        handleFileClick,
        handleRemoveFile,
        idPrefix,
        selectableFiles,
        selectedFileText,
        handleSelect,
    ]);
    var lightboxSlides = (0, react_1.useMemo)(function () {
        return media
            .filter(function (file) { return file.original && !file.removed; })
            .map(function (file) { return ({
            video: isVideo(file),
            displaySrc: file.optimizedSrc,
            downloadSrc: file.originalSrc,
            name: file.name,
        }); });
    }, [isVideo, media]);
    (0, react_1.useEffect)(function () {
        setMedia(existingMedia);
    }, [existingMedia]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ className: classes.root, display: "flex", height: "250px", justifyContent: "space-around", alignItems: "center" }, props, { children: [editable && ((0, jsx_runtime_1.jsx)(UploadAttachmentsTile_1.UploadAttachmentsTile, { p: 0, "data-testid": "attachment-tile", idPrefix: idPrefix, acceptedFileTypes: acceptedFileTypes, name: "upload new files", width: landingButtonSize, height: landingButtonSize, flexGrow: 0, flexShrink: 0, onChange: function (newFiles) {
                            return handleAddFiles(newFiles);
                        } })), (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ className: classes.slider, flexGrow: 1, flexShrink: 1, height: "100%", style: {
                            maxWidth: editable ? "calc(100% - ".concat(landingButtonSize, ")") : "100%",
                        } }, { children: (0, jsx_runtime_1.jsx)(react_2.Swiper, __assign({ slidesPerView: "auto", spaceBetween: 30, navigation: true, className: "attachment-landing-zone__swiper" }, { children: slides })) }))] })), Boolean(files.length) && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ mt: 2, flexGrow: 1 }, { children: fileChips }))), typeof currentSlide !== "undefined" && ((0, jsx_runtime_1.jsx)(Lightbox_1.Lightbox, { slides: lightboxSlides, open: typeof currentSlide !== "undefined" &&
                    Boolean(lightboxSlides.length), startingSlide: currentSlide, onClose: function () { return handleLightboxClose(); } }))] }));
});
